import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

const useNetworkOptimization = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleOnline = () => {
      queryClient.invalidateQueries({ queryKey: ["orders"] });
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
      queryClient.invalidateQueries({ queryKey: ["current-session"] });
      queryClient.invalidateQueries({ queryKey: ["session-invoices"] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["coupons"] });
      }, 2000);
    };

    const handleOffline = () => {
      // Handle offline state
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        queryClient.invalidateQueries({
          queryKey: ["orders"],
          exact: false,
          predicate: (query) => {
            const now = Date.now();
            return now - (query.state.dataUpdatedAt || 0) > 30000; // أكثر من 30 ثانية
          },
        });

        queryClient.invalidateQueries({
          queryKey: ["invoices"],
          exact: false,
          predicate: (query) => {
            const now = Date.now();
            return now - (query.state.dataUpdatedAt || 0) > 30000;
          },
        });

        queryClient.invalidateQueries({
          queryKey: ["session-invoices"],
          exact: false,
          predicate: (query) => {
            const now = Date.now();
            return now - (query.state.dataUpdatedAt || 0) > 30000;
          },
        });
      }
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [queryClient]);

  useEffect(() => {
    const cleanupOldData = () => {
      const thirtyMinutesAgo = Date.now() - 30 * 60 * 1000;

      queryClient
        .getQueryCache()
        .findAll()
        .forEach((query) => {
          if (
            query.state.dataUpdatedAt &&
            query.state.dataUpdatedAt < thirtyMinutesAgo
          ) {
            // لا تحذف البيانات الأساسية
            const isEssentialData = [
              "categories",
              "services",
              "subscriptions",
              "current-session",
              "session-invoices",
            ].some((key) => query.queryKey.includes(key));

            if (!isEssentialData) {
              queryClient.removeQueries({ queryKey: query.queryKey });
            }
          }
        });
    };

    const interval = setInterval(cleanupOldData, 10 * 60 * 1000); // كل 10 دقائق

    return () => clearInterval(interval);
  }, [queryClient]);
};

export default useNetworkOptimization;
